export const LOCATION_CHANGE = "LOCATION_CHANGE";
export const LOCATION_INITIALIZE = "LOCATION_INITIALIZE";
